import { api } from '@/common/api';
import qs from 'qs';

const store = {
    namespaced: true,
    state() {
        return {
            debts: []
        };
    },

    mutations: {
        setDebts(state, data) {
            state.debts = data;
        },
        clearStore(state) {
            state.debts = [];
        }
    },
    actions: {
        async getEmployersDebts({ state, commit }) {
            try {
                const response = await api.get('/debts/employers/');
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getDeliveryDebts({ state, commit }) {
            try {
                const response = await api.get('/debts/delivery/');
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getInstallerDealDebts({ state, commit }, { entityId }) {
            try {
                const response = await api.get(`/debt/deals/installer/${entityId}/`);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getEmployerDebts({ state, commit }, { entityId }) {
            try {
                const response = await api.get(`/debt/employer/${entityId}/`);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getInstallerDebts({ state, commit }, { entityId }) {
            try {
                const response = await api.get(`/debt/installer/${entityId}/`);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getUnaccountedDeals({ state, commit }, { measurerId }) {
            try {
                const response = await api.get(`/debt/deals/unaccounted/${measurerId}`);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getDealContactDebt({ state, commit }, params) {
            try {
                const response = await api.get(`/debt/deals/contact/?${qs.stringify(params)}`);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        },
        async getContactsDealDebts({ state, commit }, params) {
            try {
                const response = await api.get(`/debts/contacts/?${qs.stringify(params)}`);
                return response.data.data;
            } catch (e) {
                throw new Error('Произошла ошибка: ' + e.response.data.error);
            }
        }
    }
};

export default store;
